import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";

import { Itinerario } from "../../models/itinerario";

@Component({
  selector: "app-itinerario",
  templateUrl: "./itinerario.component.html",
  styleUrls: ["./itinerario.component.scss"],
})
export class ItinerarioComponent implements OnInit {
  @Input() itinerario: Itinerario[];
  @Input() modifications: boolean;

  disableModifications: boolean = true;
  roundtrip: boolean = true;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    localStorage.setItem("itinerario_copy", JSON.stringify(this.itinerario));
    this.roundtrip = this.itinerario[0].ar;
  }

  getDidUserModify(): boolean {
    return this.disableModifications;
  }

  onModificationsSwitch() {
    this.disableModifications = !this.disableModifications;

    if (this.disableModifications) {
      const itinerarioCopy: Itinerario[] = JSON.parse(
        localStorage.getItem("itinerario_copy")
      );

      itinerarioCopy.forEach((route: Itinerario, idx: number) => {
        this.itinerario[idx] = route;
      });

      this.roundtrip = this.itinerario[0].ar;
    }
  }

  onRoundTripSwitch() {
    this.roundtrip = !this.roundtrip;
    this.itinerario.length = 1;
    this.itinerario[0].ar = this.roundtrip;
  }

  onDeleteItineraryClick(idx: number) {
    if (!this.roundtrip) {
      this.itinerario.splice(idx, 1);
      this.changeDetector.detectChanges();
    }
  }

  onAddItineraryClick() {
    if (!this.roundtrip) {
      this.itinerario.push({
        da: "",
        a: "",
        ar: false,
      });
    }

    this.changeDetector.detectChanges();
  }

  omitSpecialCharacters(event: KeyboardEvent): void {
    const restrictedChars = `$()=*+#/.,;':"{}[]\\\t\n\r\0\b\f<>%&|^~\``;

    if (restrictedChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  updateItineraryFrom(event: any, index: number) {
    this.itinerario[index].da = event.target.value.trim();
    this.changeDetector.detectChanges();
  }

  updateItineraryTo(event: any, index: number) {
    this.itinerario[index].a = event.target.value.trim();
    this.changeDetector.detectChanges();
  }

  checkShouldDisableItineraryDelete(): boolean {
    return this.itinerario.length === 1 || this.roundtrip;
  }

  checkShouldDisableItineraryAdd(): boolean {
    return this.roundtrip;
  }
}
